import React from "react";
import { Link } from "react-router-dom";
import {
    addDoc,
    collection,
    serverTimestamp,
    getDocs,
    orderBy,
    query,
} from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import { NAVBAR_ITEMS } from "../../Components/Navbar/Navbar";
import InelImg from "../../Assets/smart-sanitas/inel.png";
import BrataraImg from "../../Assets/smart-sanitas/bratara.jpg";
import BrelocImg from "../../Assets/smart-sanitas/breloc.png";
import CardImg from "../../Assets/smart-sanitas/card-digital.png";
import "./membri-de-sindicat.css";

// (optional fallback image, if you want to also show a static illustration somewhere)
import SizeGuideImg from "../../Assets/size-guide.png";

// If you have a canvas component already created, you can use it;
// otherwise comment this import and the <SizeGuideCanvas/> usage.
// import SizeGuideCanvas from "../../Components/SizeGuideCanvas/SizeGuideCanvas";

export function MembriDeSindicatPage() {
    function OrderForm() {
        const [form, setForm] = React.useState({
            product: "card", // inel | bratara | breloc | card
            quantity: 1,
            fullName: "",
            email: "",
            phone: "",
            organization: "",
            address: "",
            notes: "",
            consent: false,
            // 🔥 NEW: ring sizing fields that will be sent to Firestore
            ringCircumference: "", // in mm (string for the input)
            ringSizeLabel: "",     // e.g. "8" (US/EU simplified label from table)
        });

        // 🔢 Size conversion table + helper
        const SIZE_TABLE = [
            //  mm ,  diam  ,  label aproximativ (US/EU simplificat)
            { mm: 50, inner: 16.0, label: "6" },
            { mm: 53, inner: 16.9, label: "7" },
            { mm: 56, inner: 17.8, label: "8" },
            { mm: 59, inner: 18.8, label: "9" },
            { mm: 62, inner: 19.7, label: "10" },
            { mm: 65, inner: 20.7, label: "11" },
            { mm: 68, inner: 21.6, label: "12" },
            { mm: 71, inner: 22.6, label: "13" },
            { mm: 74, inner: 23.5, label: "14" },
        ];

        // returnează intrarea din tabel cea mai apropiată de mm introdus
        function mmToSizeEntry(mm: number) {
            let best = SIZE_TABLE[0];
            let bestDiff = Math.abs(mm - best.mm);
            for (const row of SIZE_TABLE) {
                const d = Math.abs(mm - row.mm);
                if (d < bestDiff) {
                    best = row;
                    bestDiff = d;
                }
            }
            return best;
        }

        function mmForLabel(label: string): number | null {
            const row = SIZE_TABLE.find((r) => r.label === label);
            return row ? row.mm : null;
        }

        const [sending, setSending] = React.useState(false);
        const [msg, setMsg] = React.useState<string | null>(null);

        // NEW: institutes dropdown data
        const [institutes, setInstitutes] = React.useState<string[]>([]);
        const [instLoading, setInstLoading] = React.useState<boolean>(true);
        const [instErr, setInstErr] = React.useState<string>("");

        React.useEffect(() => {
            (async () => {
                try {
                    setInstLoading(true);
                    setInstErr("");
                    const snap = await getDocs(
                        query(collection(db, "institutes"), orderBy("name"))
                    );
                    const names = snap.docs
                        .map((d) => (d.data() as any)?.name as string)
                        .filter(Boolean);
                    setInstitutes(names);
                } catch (e) {
                    console.error(e);
                    setInstErr("Nu s-au putut încărca instituțiile.");
                } finally {
                    setInstLoading(false);
                }
            })();
        }, []);

        const onChange = (
            e:
                | React.ChangeEvent<HTMLInputElement>
                | React.ChangeEvent<HTMLTextAreaElement>
                | React.ChangeEvent<HTMLSelectElement>
        ) => {
            const { name, value, type, checked } = e.target as any;

            // interceptăm câmpul ringCircumference ca să calculăm automat mărimea
            if (name === "ringCircumference") {
                const v = value;
                let sizeLabel = "";
                if (v && !isNaN(parseFloat(v))) {
                    const mm = parseFloat(v);
                    const entry = mmToSizeEntry(mm);
                    sizeLabel = entry.label;
                }
                setForm((p) => ({ ...p, ringCircumference: v, ringSizeLabel: sizeLabel }));
                return;
            }

            setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
        };

        const onSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            setMsg(null);

            // Validări minime
            if (!form.fullName || !form.email || !form.phone || !form.organization) {
                setMsg("Te rugăm să completezi câmpurile obligatorii.");
                return;
            }
            if (!form.consent) {
                setMsg("Trebuie să îți exprimi acordul privind prelucrarea datelor.");
                return;
            }

            try {
                setSending(true);
                await addDoc(collection(db, "smart_orders"), {
                    ...form,
                    quantity: Number(form.quantity) || 1,
                    status: "new",
                    createdAt: serverTimestamp(),
                });
                setMsg("✔️ Comanda a fost trimisă. Te vom contacta în curând.");
                // Reset (inclusiv câmpurile de mărime)
                setForm({
                    product: "inel",
                    quantity: 1,
                    fullName: "",
                    email: "",
                    phone: "",
                    organization: "",
                    address: "",
                    notes: "",
                    consent: false,
                    ringCircumference: "",
                    ringSizeLabel: "",
                });
            } catch (err) {
                console.error(err);
                setMsg("❌ A apărut o eroare. Încearcă din nou.");
            } finally {
                setSending(false);
            }
        };

        // === Interactive SizePicker (folosește closure ca să actualizeze form) ===



        return (
            <section className="section order-form">
                {/* === GHID DE MĂSURARE ===================================== */}
                <section className="section smart-guide center-block">
                    <h2 className="center-title">Ghid de măsurare – alege mărimea corectă</h2>

                    <div className="guide-grid center-narrow">
                        {/* Stânga: pași text + (opțional) imagine/pictogramă */}
                        <div className="guide-text">
                            <ol className="steps">
                                <li>
                                    <span className="step-number">1</span>
                                    <div>
                                        <h4>Pregătește</h4>
                                        <p>Taie o bandă subțire de hârtie sau folosește un șnur.</p>
                                    </div>
                                </li>
                                <li>
                                    <span className="step-number">2</span>
                                    <div>
                                        <h4>Măsoară</h4>
                                        <p>
                                            Înfașoară în jurul degetului și marchează punctul unde capetele
                                            se întâlnesc.
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <span className="step-number">3</span>
                                    <div>
                                        <h4>Notează mm</h4>
                                        <p>Măsoară cu rigla lungimea în milimetri (ex: 56–57 mm).</p>
                                    </div>
                                </li>
                                <li>
                                    <span className="step-number">4</span>
                                    <div>
                                        <h4>Alege mărimea</h4>
                                        <p>
                                            Introdu mm mai jos sau apasă o mărime din grilă — îți calculăm
                                            automat mărimea potrivită.
                                        </p>
                                    </div>
                                </li>
                            </ol>



                            {/* Dacă ai componentă Canvas, o poți adăuga aici, păstrând imaginea ca fallback:
              <div className="size-canvas">
                <SizeGuideCanvas />
              </div>
              */}
                        </div>


                    </div>
                </section>

                <h2>
                    Finalizează comanda acum, fără plată. Vei primi instrucțiunile de plată
                    ulterior
                </h2>
                <p className="order-lead">
                    Completează formularul pentru a primi gratuit Cardul digital Smart SANITAS, oferit membrilor pentru acces la servicii și beneficii.
                    Dacă dorești o versiune extinsă, cu funcții suplimentare (inel, brățară sau breloc Smart SANITAS), o poți selecta din meniu — aceste variante sunt disponibile contra cost.
                </p>

                <form onSubmit={onSubmit} className="of-grid">
                    <div className="of-field">
                        <label>Produs</label>
                        <select name="product" value={form.product} onChange={onChange}>
                            <option value="card">Card digital (GRATUIT)</option>
                            <option value="breloc">Breloc Smart (499 lei / membru)</option>
                            <option value="inel">Inel Smart (499 lei / membru)</option>
                            <option value="bratara">Brățară Smart (499 lei / membru)</option>
                        </select>
                    </div>

                    <div className="of-field">
                        <label>Cantitate</label>
                        <input
                            type="number"
                            name="quantity"
                            min={1}
                            max={10}
                            value={form.quantity}
                            onChange={onChange}
                        />
                    </div>

                    {/* 🔥 NEW: câmp pentru circumferință + preview mărime calculată */}
                    <div className="of-field">
                        <label>Circumferință deget (mm)</label>
                        <input
                            type="number"
                            name="ringCircumference"
                            step="0.1"
                            min={45}
                            max={80}
                            placeholder="Ex: 56.5"
                            value={form.ringCircumference}
                            onChange={onChange}
                        />
                    </div>

                    <div className="of-field">
                        <label>Mărime recomandată</label>
                        <input
                            value={form.ringSizeLabel ? `~ ${form.ringSizeLabel}` : ""}
                            placeholder="Se calculează automat"
                            readOnly
                        />
                    </div>

                    <div className="of-field wide">
                        <label>Nume complet *</label>
                        <input
                            name="fullName"
                            placeholder="Nume și prenume"
                            value={form.fullName}
                            onChange={onChange}
                            required
                        />
                    </div>

                    <div className="of-field">
                        <label>Email *</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="exemplu@domeniu.ro"
                            value={form.email}
                            onChange={onChange}
                            required
                        />
                    </div>

                    <div className="of-field">
                        <label>Telefon *</label>
                        <input
                            name="phone"
                            placeholder="07xx xxx xxx"
                            value={form.phone}
                            onChange={onChange}
                            required
                        />
                    </div>

                    {/* ==== ORGANIZAȚIE DIN FIRESTORE (DROPDOWN) ==== */}
                    <div className="of-field wide">
                        <label>Organizație / Unitate *</label>

                        {instLoading ? (
                            <input value="Se încarcă instituțiile…" disabled />
                        ) : institutes.length > 0 ? (
                            <select
                                name="organization"
                                value={form.organization}
                                onChange={onChange}
                                required
                            >
                                <option value="">Selectează instituția</option>
                                {institutes.map((name) => (
                                    <option key={name} value={name}>
                                        {name}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <>
                                <input
                                    name="organization"
                                    placeholder={
                                        instErr
                                            ? "Eroare la încărcarea listelor — introdu manual"
                                            : "Nu există instituții — introdu manual"
                                    }
                                    value={form.organization}
                                    onChange={onChange}
                                    required
                                />
                                {instErr && <small style={{ color: "#a00" }}>{instErr}</small>}
                            </>
                        )}
                    </div>

                    <div className="of-field wide">
                        <label>Adresă (opțional)</label>
                        <input
                            name="address"
                            placeholder="Stradă, număr, oraș"
                            value={form.address}
                            onChange={onChange}
                        />
                    </div>

                    <div className="of-field wide">
                        <label>Observații (opțional)</label>
                        <textarea
                            name="notes"
                            rows={3}
                            placeholder="Mărime inel / preferințe culoare / alte informații utile"
                            value={form.notes}
                            onChange={onChange}
                        />
                    </div>

                    <label className="of-consent wide">
                        <input
                            type="checkbox"
                            name="consent"
                            checked={form.consent}
                            onChange={onChange}
                        />
                        <span>
              Sunt de acord cu prelucrarea datelor personale pentru procesarea
              comenzii (GDPR).
            </span>
                    </label>

                    {msg && <p className="of-msg">{msg}</p>}

                    <div className="of-actions wide">
                        <button type="submit" className="btn btn-primary" disabled={sending}>
                            {sending ? "Se trimite..." : "Trimite comanda"}
                        </button>
                        <a
                            className="btn btn-ghost"
                            href="https://www.flexpayz.se/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Vezi detalii produse
                        </a>
                    </div>
                </form>
            </section>
        );
    }

    return (
        <div className="page-container">
            <Navbar />

            <div className="page-content membri-page">
                {/* Hero */}
                <section className="hero">
                    <div className="hero-inner">
                        <h1>Membri de sindicat</h1>
                        <p className="lead">
                            Împreună apărăm drepturile profesionale și creăm condiții mai bune de
                            muncă. Află beneficiile, pașii de înscriere și resursele utile pentru
                            membrii SANITAS București.
                        </p>

                        <div className="hero-ctas">
                            <a
                                className="btn btn-primary"
                                href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Înscriere aplicație
                            </a>
                        </div>
                    </div>
                </section>

                {/* Benefits */}
                <section className="section">
                    <h2>Beneficii pentru membri</h2>
                    <div className="benefits-grid">
                        <article className="card">
                            <h3>Reprezentare & negociere</h3>
                            <p>
                                Reprezentare în dialogul cu angajatorii și autoritățile, negocieri
                                colective pentru drepturi salariale și condiții corecte.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Asistență juridică</h3>
                            <p>
                                Consultanță și sprijin juridic în problemele de muncă: contracte,
                                drepturi, litigii.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Informare & training</h3>
                            <p>
                                Acces la informări periodice, ghiduri, webinarii și instruiri dedicate
                                membrilor.
                            </p>
                        </article>
                        <article className="card">
                            <h3>Comunitate & sprijin</h3>
                            <p>
                                Comunitate activă, proiecte sociale și inițiative pentru bunăstarea
                                membrilor.
                            </p>
                        </article>
                    </div>
                </section>

                {/* === OFERTA SMART SANITAS =================================== */}
                <section className="section smart-offer">
                    <h2>Smart SANITAS</h2>
                    <p className="smart-lead">
                        Pentru a folosi aplicația <strong>Smart SANITAS</strong> ai nevoie de un
                        gadget dedicat (cu serviciu de plată inclus) sau poți opta pentru un{" "}
                        <strong>card digital gratuit</strong>.
                    </p>

                    <div className="products-grid">

                        {/* Card digital (fără plată) */}
                        <article className="product-card free">
                            <div className="media">
                                <img src={CardImg} alt="Card digital SANITAS" />
                            </div>
                            <div className="body">
                                <h3>Card digital (gratuit)</h3>
                                <p className="desc">
                                    Dacă nu dorești un wearable cu plată, primești <strong>gratuit</strong>{" "}
                                    un card digital personalizat de la organizația ta pentru acces în
                                    aplicație.
                                </p>

                                <div className="price">
                                    <span className="new free-tag">GRATUIT</span>
                                </div>
                                <div className="split">
                                    <span className="chip neutral">Fără serviciu de plată</span>
                                </div>

                                <a
                                    className="btn btn-ghost wide"
                                    href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Solicită card digital
                                </a>
                            </div>
                        </article>
                        {/* Inel */}
                        <article className="product-card">
                            <div className="media">
                                <img src={InelImg} alt="Inel Smart SANITAS" />
                            </div>
                            <div className="body">
                                <h3>Inel Smart</h3>
                                <p className="desc">
                                    Inel inteligent cu serviciu de plată + funcții integrate în aplicație.
                                </p>

                                <div className="price">
                                    <span className="old">499 lei</span>
                                    <span className="new">250 lei</span>
                                </div>
                                <div className="split">
                  <span className="chip you">
                    Pret subventionat pt membru de sindicat <strong></strong>
                  </span>
                                </div>

                                <a
                                    className="btn btn-primary wide"
                                    href="https://www.flexpayz.se/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Cumpără de pe flexpayz.se
                                </a>
                            </div>
                        </article>

                        {/* Brățară */}
                        <article className="product-card">
                            <div className="media">
                                <img src={BrataraImg} alt="Brățară Smart SANITAS" />
                            </div>
                            <div className="body">
                                <h3>Brățară Smart</h3>
                                <p className="desc">
                                    Brățară confortabilă cu plată contactless + integrare completă în
                                    aplicație.
                                </p>

                                <div className="price">
                                    <span className="old">625 lei</span>
                                    <span className="new">350lei</span>
                                </div>
                                <div className="split">
                                    <span className="chip you">Pret subventionat pt membru de sindicat</span>
                                </div>

                                <a
                                    className="btn btn-primary wide"
                                    href="https://www.flexpayz.se/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Cumpără de pe flexpayz.se
                                </a>
                            </div>
                        </article>

                        {/* Breloc */}
                        <article className="product-card">
                            <div className="media">
                                <img src={BrelocImg} alt="Breloc Smart SANITAS" />
                            </div>
                            <div className="body">
                                <h3>Breloc Smart</h3>
                                <p className="desc">
                                    Breloc rezistent cu plată integrată—mereu la îndemână, încheiat la
                                    chei.
                                </p>

                                <div className="price">
                                    <span className="old">499 lei</span>
                                    <span className="new">250 lei</span>
                                </div>
                                <div className="split">
                                    <span className="chip you">Pret subventionat pt membru de sindicat</span>
                                </div>

                                <a
                                    className="btn btn-primary wide"
                                    href="https://www.flexpayz.se/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Cumpără de pe flexpayz.se
                                </a>
                            </div>
                        </article>


                    </div>

                    <p className="footnote">
                        *Prețurile afișate sunt pentru membri SANITAS. Organizația subvenționează o
                        parte din cost, astfel încât <strong>tu plătești doar 250 lei</strong> pentru
                        wearables cu serviciu de plată.
                    </p>
                </section>

                {/* Steps */}
                <section className="section">
                    <OrderForm />
                    <h2>Cum te înscrii</h2>
                    <ol className="steps">
                        <li>
                            <span className="step-number">1</span>
                            <div>
                                <h4>Completează cererea</h4>
                                <p>
                                    Descarcă modelul sau folosește butonul „Înscriere aplicație”.
                                    Completează datele corect.
                                </p>
                            </div>
                        </li>
                        <li>
                            <span className="step-number">2</span>
                            <div>
                                <h4>Depune documentele</h4>
                                <p>
                                    Transmite cererea la reprezentantul SANITAS din unitatea ta sau
                                    încarcă documentele în aplicație.
                                </p>
                            </div>
                        </li>
                        <li>
                            <span className="step-number">3</span>
                            <div>
                                <h4>Confirmarea calității de membru</h4>
                                <p>Primești confirmarea și poți accesa beneficiile dedicate.</p>
                            </div>
                        </li>
                        <li>
                            <span className="step-number">4</span>
                            <div>
                                <h4>Conectează-te în aplicație</h4>
                                <p>
                                    Urmărește noutăți, comunicate, evenimente și resurse juridice direct
                                    din contul tău.
                                </p>
                            </div>
                        </li>
                    </ol>

                    <div className="steps-cta">
                        <a
                            className="btn btn-primary"
                            href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Înscriere aplicație
                        </a>
                        <a className="btn btn-ghost" href="/contact">
                            Ai întrebări? Contactează-ne
                        </a>
                    </div>
                </section>

                {/* Quote band */}
                <section className="band">
                    <p>
                        „Împreună suntem mai puternici.” — Alătură-te și fă parte din vocea
                        colectivă a profesioniștilor din sănătate.
                    </p>
                </section>

                {/* FAQ */}
                <section className="section">
                    <h2>Întrebări frecvente</h2>
                    <div className="faq">
                        <details>
                            <summary>Care sunt condițiile de înscriere?</summary>
                            <p>
                                Pot deveni membri angajații din domeniul sanitar din București care
                                acceptă statutul și regulamentele organizației.
                            </p>
                        </details>
                        <details>
                            <summary>Cum plătesc cotizația?</summary>
                            <p>
                                Cotizația poate fi reținută direct din salariu conform opțiunii exprimate
                                în cerere sau achitată prin metodele comunicate de organizație.
                            </p>
                        </details>
                        <details>
                            <summary>Unde găsesc informații juridice?</summary>
                            <p>
                                Vizitează secțiunea <a href="/juridic/legislatie">Juridic → Legislație</a>{" "}
                                sau contactează departamentul juridic pentru situații specifice.
                            </p>
                        </details>
                    </div>
                </section>

                {/* Contact/help card */}
                <section className="section contact-help">
                    <div className="help-card">
                        <h3>Ai nevoie de ajutor?</h3>
                        <p>
                            Echipa noastră te sprijină cu informații despre înscriere, statut,
                            drepturi și obligații. Scrie-ne sau programează o discuție.
                        </p>
                        <div className="hero-ctas">
                            <a className="btn btn-ghost" href="/contact">
                                Contact
                            </a>
                            <a
                                className="btn btn-primary"
                                href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Înscriere aplicație
                            </a>
                        </div>
                    </div>
                </section>

                {/* === GHID DE UTILIZARE APLICAȚIE ============================ */}
                <section className="section smart-guide">
                    <h2>Ghid de utilizare – Smart SANITAS</h2>

                    <ol className="steps">
                        <li>
                            <span className="step-number">1</span>
                            <div>
                                <h4>Comandă sau solicită acces</h4>
                                <p>
                                    Alege un gadget (inel, brățară, breloc) de pe{" "}
                                    <a
                                        href="https://flexpayz.se/products"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Cumpără de pe flexpayz.se
                                    </a>{" "}
                                    sau solicită <strong>cardul digital gratuit</strong>.
                                </p>
                            </div>
                        </li>

                        <li>
                            <span className="step-number">2</span>
                            <div>
                                <h4>Activează în aplicație</h4>
                                <p>Primești instrucțiuni de activare…</p>
                            </div>
                        </li>

                        <li>
                            <span className="step-number">3</span>
                            <div>
                                <h4>Configurează plățile (opțional)</h4>
                                <p>Adaugă metoda de plată…</p>
                            </div>
                        </li>

                        <li>
                            <span className="step-number">4</span>
                            <div>
                                <h4>Folosește beneficiile</h4>
                                <p>Accesează noutăți, legitimație digitală…</p>
                            </div>
                        </li>
                    </ol>

                    <div className="steps-cta">
                        <a
                            className="btn btn-primary"
                            href="https://www.flexpayz.se/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Mergi la magazin (flexpayz.se)
                        </a>
                        <a
                            className="btn btn-ghost"
                            href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Înscriere aplicație
                        </a>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
}